import * as React from 'react';
import { callAll } from '../helper/fp';
import { validateEmail } from '../helper/validate';
import { Input, InputProps } from '../Input/Input';

export type EmailInputProps = {
  onValidityChange?: (isValid: boolean | undefined) => void;
  /** control if `onValidityChange` should be called onChange, else it will be called onBlur */
  validateOnChange?: boolean;
} & InputProps;

export const EmailInput = React.forwardRef<HTMLInputElement, EmailInputProps>(function EmailInputComp(
  { onValidityChange, onChangeValue, validateOnChange, onBlur, ...inputProps },
  ref
) {
  const validateValue = onValidityChange
    ? (value: string) => {
        if (value === '' && !inputProps.required) {
          onValidityChange(undefined);
        } else {
          onValidityChange(validateEmail(value));
        }
      }
    : undefined;

  return (
    <Input
      {...inputProps}
      onChangeValue={validateOnChange ? callAll(onChangeValue, validateValue) : onChangeValue}
      onBlur={validateValue && !validateOnChange ? callAll(onBlur, (ev) => validateValue(ev.target.value)) : onBlur}
      ref={ref}
    />
  );
});
